/**
 * Mixin กลางสำหรับเครื่องมือแอดมิน "สวมสิทธิ์ผู้ใช้งาน" (Switch User)
 * ใช้ร่วมกันโดย switch_user.vue, userAdmin.vue, user.vue — แทนที่โค้ดซ้ำเดิมที่เรียก
 * login.php?crud=adminImpersonateUser ตรงๆ (endpoint นั้นถูกลบไปแล้ว ดู login.php)
 *
 * รีโหลดหน้าเต็ม (window.location.href) ทั้งตอนเริ่มและตอนจบการสวมสิทธิ์ เพราะระบบนี้เก็บ
 * ข้อมูลผู้ใช้เป็น component-local state ทั้งหมด ไม่มี central store ที่จะ reactive ตามการ
 * เปลี่ยน localStorage.user ระหว่างทาง (ดู PROJECT_AUDIT.md หัวข้อสถาปัตยกรรม frontend)
 */
export const impersonationMixin = {
  methods: {
    impersonationRouteFor(subjectType, targetData) {
      if (subjectType === "user") {
        const roleRouteMap = {
          A: "/admin",
          B: "/college",
          C: "/iven",
          G: "/vecprovince",
          S: "/supervisions",
        };
        return roleRouteMap[targetData.user_status] || "/";
      }
      const typeRouteMap = {
        personnel_temporary: "/user",
        personnel_etc: "/userEtc",
        assistantteach: "/assistantTeach",
      };
      return typeRouteMap[subjectType] || "/";
    },

    async startImpersonation({ subjectType, subjectId, displayName }) {
      const confirmResult = await Swal.fire({
        icon: "warning",
        title: "ยืนยันเข้าใช้งานแทนบัญชีนี้?",
        html: `บัญชีเป้าหมาย: <b>${displayName || subjectId}</b><br>การกระทำนี้จะถูกบันทึกลงประวัติการสวมสิทธิ์ (Security Monitor)`,
        showCancelButton: true,
        confirmButtonText: "เข้าใช้งานแทน",
        cancelButtonText: "ยกเลิก",
      });
      if (!confirmResult.isConfirmed) return;

      try {
        const result = await this.$http.post("admin.impersonate_start.php", {
          target_subject_type: subjectType,
          target_subject_id: subjectId,
        });

        if (!result.data || !result.data.status) {
          Swal.fire({
            icon: "error",
            title:
              (result.data && result.data.message) || "สวมสิทธิ์ไม่สำเร็จ",
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }

        // เก็บ session แอดมินเดิมไว้ก่อนเขียนทับ — ใช้คืนตอนกด "กลับสู่บัญชีผู้ดูแลระบบ"
        const currentUserRaw = localStorage.getItem("user");
        if (currentUserRaw) {
          localStorage.setItem("impersonation_admin_backup", currentUserRaw);
        }
        // force_password_change เป็น key กลางของเบราว์เซอร์ (ไม่ผูกกับบัญชี) ตั้งค่าตอน login จริงครั้งล่าสุด
        // เท่านั้น (ดู loginuser.vue) ถ้าไม่เคลียร์ตรงนี้ ค่าที่ค้างจาก login จริงของแอดมินเองจะหลุดเข้าไป
        // บังคับให้บัญชีที่ถูกสวมสิทธิ์ต้องเปลี่ยนรหัสผ่านทั้งที่ไม่เกี่ยวข้องกันเลย
        localStorage.setItem(
          "impersonation_force_password_change_backup",
          localStorage.getItem("force_password_change") || "0"
        );
        localStorage.setItem("force_password_change", "0");

        const target = result.data.data;
        localStorage.setItem("user", JSON.stringify(target));

        const route = this.impersonationRouteFor(subjectType, target);
        window.location.href = "/#" + route;
      } catch (error) {
        console.error("startImpersonation error:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการเชื่อมต่อ กรุณาลองใหม่",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    async endImpersonation() {
      try {
        await this.$http.post("admin.impersonate_end.php", {});
      } catch (error) {
        console.error("endImpersonation error:", error);
        // ยังคืนค่าบัญชีแอดมินต่อแม้ revoke ฝั่งเซิร์ฟเวอร์ล้มเหลว — ไม่ให้แอดมินติดอยู่ในบัญชีคนอื่น
      }

      const backup = localStorage.getItem("impersonation_admin_backup");
      if (backup) {
        localStorage.setItem("user", backup);
        localStorage.removeItem("impersonation_admin_backup");
      }
      const pwBackup = localStorage.getItem(
        "impersonation_force_password_change_backup"
      );
      if (pwBackup !== null) {
        localStorage.setItem("force_password_change", pwBackup);
        localStorage.removeItem("impersonation_force_password_change_backup");
      }
      window.location.href = "/#/admin";
    },
  },
};
